/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ActuatorHealthStatusDetails } from './actuatorHealthStatusDetails';


/**
 * One piece of health information
 */
export interface ActuatorHealthInfo { 
    /**
     * UP — The component or subsystem is working as expected  DOWN — The component is not working  OUT_OF_SERVICE — The component is out of service temporarily  UNKNOWN — The component state is unknown
     */
    status: ActuatorHealthInfo.StatusEnum;
    details?: ActuatorHealthStatusDetails;
}
export namespace ActuatorHealthInfo {
    export type StatusEnum = 'UP' | 'DOWN' | 'OUT_OF_SERVICE' | 'UNKNOWN';
    export const StatusEnum = {
        Up: 'UP' as StatusEnum,
        Down: 'DOWN' as StatusEnum,
        OutOfService: 'OUT_OF_SERVICE' as StatusEnum,
        Unknown: 'UNKNOWN' as StatusEnum
    };
}


